import { useQuery } from '@tanstack/react-query';

import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';

export function useKnowYourLoanSummaryQuery() {
  const { obfuscatedLoanIdentifier } = useUrl();

  return useQuery({
    queryKey: ['knowYourLoanSummary'],
    queryFn: async () => {
      const response =
        await typedApiClient.v1.knowYourLoanGetKnowYourLoanSummary(
          obfuscatedLoanIdentifier,
        );

      return response?.data;
    },
    refetchOnWindowFocus: false,
  });
}
